import React, { useEffect, useState } from "react";
import "../../assets/scss/pages/quiz.scss";
import { Col, Row } from "react-bootstrap";
import ApiService from "../../services/ApiService";
import { callAlert, callAlertConfirm } from "../../services/CommonService";
import { TiTick } from "react-icons/ti";
import { MdClose } from "react-icons/md"; 

function LearningQuiz(props) {
  const { type, setType, quizData, outputData } = props;
 

  const [quiz, setQuiz] = useState();
  const [defaultChecked, setDefaultChecked] = useState();
  const [defaultCheckedClass, setDefaultCheckedClass] = useState({});
  const [error, setError] = useState(null);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [completeQuestion , setCompleteQuestion] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [validationResult, setValidationResult] = useState();
  const [isAnswerValidated, setIsAnswerValidated] = useState(false);
  const [answerIndex, setAnswerIndex] = useState();
  const [retryActive, setRetryActive] = useState(false);
  const [selectedAnsStatus, setSelectedAnsStatus] = useState(false);
  const [quizStatus, setQuizStatus] = useState("PENDING");
  const [selectedAns, setSelectedAns] = useState({
    id: "",
    quizId: "",
    answer: "",
  });

  const usedEmojis = ["💥", "🥁"];

  function createFinalRainfall() {
    const rainfallContainer = document.getElementById("rainfall");
    rainfallContainer.innerHTML = ""; // Clear previous rainfall
    for (let i = 0; i < 100; i++) {
      const span = document.createElement("span");
      span.textContent =
        usedEmojis[Math.floor(Math.random() * usedEmojis.length)];
      span.style.left = Math.random() * 100 + "vw";
      span.style.animationDuration = Math.random() * 3 + 2 + "s";
      span.style.fontSize = Math.random() * 2 + 1 + "em";
      rainfallContainer.appendChild(span);
    }

    setTimeout((d) => {
      rainfallContainer.style.display = "none";
    }, 6000);
  }
  const fetchData = async () => {
    setRetryActive(false);
    try {
      setCurrentQuestionIndex(0);
      setSelectedAnsStatus(false); 
      setCompleteQuestion(0);
      setDefaultCheckedClass({});
      console.log(quizData)
      const response = await ApiService.publicPostRequest(
        `/quiz/findquiz`,{
          "quizId": quizData.quiz || quizData.quizId,
          "courseName": quizData.courseName || " ",
          "videoName": quizData.videoName || " ",
          "moduleName": quizData.moduleName || " ",
          "courseId": quizData.courseId || " ",
          "modulesId": quizData.modulesId || " ",
          "videoId": quizData.videoId || " " 

        },
        true
      );

      let status = true;
      if (response?.data?.data) {
        response.data.data.questions.forEach((d, i) => {
          if (d.status === "PENDING" && status) {
            if (i > 0) {
              setCurrentQuestionIndex(i);
              setCompleteQuestion(i); 
              setQuizStatus("INPROGRESS");
            }

            status = false;
          }
        });
        setQuiz(response.data.data);
      } else {
        callAlert("", "This module will be live soon. Stay tuned! ", "info");

        // callAlert("", response.data.message);
        outputData("cancelQuiz");
      }

      setTimeout((d) => {
        //  createFinalRainfall()
      }, 1000);
    } catch (error) {
      console.error("Error fetching quiz:", error);
      // setError({
      //     message: "quiz not found",
      // });
    }
  };
  useEffect(() => {
    
    fetchData();
  }, [quizData]);

  const validateAnswer = async (q) => {
    const response = await ApiService.publicPostRequest(
      "/quiz/validate",
      {
        id: q.id,
        quizId: q.quizId,
        answer: q.answer,
      },
      true
    );
    setSelectedAnsStatus(true);
    setCompleteQuestion(completeQuestion + 1);

    if (response && response.data) {

      
      if(currentQuestionIndex + 1 == quiz.maxQuestions){
        getQuizReport(quiz.id);
      }
      
      if (response.data.message == "CORRECT") {
        let classs = { [defaultChecked]: "text-success" };
        setDefaultCheckedClass(classs);
      } else {
        let classs = {
          [defaultChecked]: "text-danger",
          [response.data?.data?.correctAnswer]: "text-success",
        };
        classs["Class"] = "text-success";
        setDefaultCheckedClass(classs);
      }
      // setValidationResult(response.data.message);
    } else {
      throw new Error("Invalid validation response structure");
    }

    setTimeout((d) => {
      setDefaultChecked("");
    }, 100);
  };

  const handleAnswerSelect = (
    e,
    choice,
    questionId,
    currentQuestion,
    answer
  ) => {
    setDefaultChecked(choice);
    let quizId = currentQuestion.quizId;

    setSelectedAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionId]: answer,
    }));

    setSelectedAns({
      id: questionId,
      quizId: quizId,
      answer: answer,
    });
  };

  const handleSubmitAnswer = () => {
    if (!selectedAns?.id) {
      callAlert("", "Please choose any one answer option​ ");
      return;
    }

    validateAnswer({
      id: selectedAns.id,
      quizId: selectedAns.quizId,
      answer: selectedAns.answer,
    });

    setSelectedAns({
      id: "",
      quizId: "",
      answer: "",
    });
  };

  const retryQuizReport = () => { 
    callAlertConfirm(
      "",
      "Are you sure you want to retry quiz?",
      (result) => {
        if (result.isConfirmed) {
          setDefaultCheckedClass({});
          setCurrentQuestionIndex(0);
          fetchData();


        } else if (result.isDenied) {
          return false;
        }
      },
      false
    );


  

  }
  const getQuizReport = (id) => {
    ApiService.publicGetRequest(`/quiz/quiz-report?id=${id}`,true) 
    .then((res) => { 

      if(res.data?.resultCode === 1){  

        if(res.data?.data['status']=="RETRY"){
          setRetryActive(true); 
        }
        

       
        
     
    }else{ 
      callAlert('', res.data?.message);
    }
 
    })
    .catch((error) => {
     
      callAlert('', error?.error?.message);

    });

  }
  const handleNextQuestion = () => {
    setDefaultCheckedClass({});
    
   
    if (currentQuestionIndex < quiz.questions.length-1 ) {
      setSelectedAnsStatus(false); 
      setCurrentQuestionIndex(currentQuestionIndex + 1); 
    } else { 

      outputData("cancelQuiz"); 
    }
  };



  const cancelQuiz = () => {
    callAlertConfirm(
      "",
      "Are you sure you want to remind me later?",
      (result) => {
        if (result.isConfirmed) {
          outputData("cancelQuiz");
        } else if (result.isDenied) {
          return false;
        }
      },
      false
    );
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (!quiz) {
    return <></>;
    // return <div>Loading...</div>;
  }

  const currentQuestion = quiz.questions[currentQuestionIndex];

  return (
    <div className="quiz-wrapper">
      {type === "step1" && (
        <div className="quiz-content">
          <h1 className="title-quiz">{quizData.videoName}</h1>
          {quizStatus === "PENDING" && (
            <>
              <div className="qustion-count mb-5">
                <span className="qustion-number mt-3 mb-3">
                  Quiz 1 | {quiz.maxQuestions} questions
                </span>
              </div>
              <Row>
                <Col className="mx-auto text-center mt-5">
                  <button
                    type="button"
                    onClick={() => cancelQuiz()}
                    className="btn btn-danger btn-primary4 me-4"
                  >
                    {" "}
                    Remind me later{" "}
                  </button>
                  <button
                    type="button"
                    onClick={() => setType("step2")}
                    className="btn btn-primary  btn-primary4"
                  >
                    {" "}
                    Start Quiz{" "}
                  </button>
                </Col>
              </Row>
            </>
          )}

          {quizStatus === "INPROGRESS" && (
            <>
              <div className="qustion-count mb-5">
                <span className="qustion-number mt-3 mb-3">
                  Completed Quiz {currentQuestionIndex + 1} |{" "}
                  {quiz.maxQuestions} questions
                </span>
              </div>
              <Row>
                <Col className="mx-auto text-center mt-5">
                  <button
                    type="button"
                    onClick={() => cancelQuiz()}
                    className="btn btn-danger btn-primary4 me-4"
                  >
                    {" "}
                    Remind me later{" "}
                  </button>
                  <button
                    type="button"
                    onClick={() => setType("step2")}
                    className="btn btn-primary  btn-primary4"
                  >
                    {" "}
                    Resume Quiz{" "}
                  </button>
                </Col>
              </Row>
            </>
          )}
        </div>
      )}

      {type === "step2" && currentQuestion && (
        <div className="quiz-content">
          {/*  <h1 className="title-quiz">{quizData.videoName}</h1> */}
          <div className="qustion-count">
            <span className="qustion-number">
              Question {currentQuestionIndex + 1} of {quiz.maxQuestions}
            </span>
          </div>
          <Row>
            <Col sm={10} className="mx-auto">
              <div className="qustions-text">{currentQuestion.question}</div>
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              <div
                className={
                  selectedAnsStatus
                    ? " answer-boxs quiz-not-allowed"
                    : "answer-boxs "
                }
              >
                {currentQuestion.choices.map((choice, index) => (
                  <div
                    key={index}
                    className={
                      defaultCheckedClass[choice]
                        ? " answer-box " + defaultCheckedClass[choice]
                        : "answer-box"
                    }
                  >
                    <input
                      type="radio"
                      name={`option-${currentQuestion.id}`}
                      id={`option-${currentQuestion.id}-${index}`}
                      value={choice}
                      checked={defaultChecked === choice}
                      disabled={selectedAnsStatus}
                      onChange={(e) =>
                        handleAnswerSelect(
                          e,
                          choice,
                          currentQuestion.id,
                          currentQuestion,
                          index
                        )
                      }
                      hidden
                    />
                    <label
                      htmlFor={`option-${currentQuestion.id}-${index}`}
                      className="answer-lable"
                    >
                      <span className="answer-number unchecked">
                        {String.fromCharCode(65 + index)}

                        <span className="TiTick">
                          {" "}
                          <TiTick />
                        </span>
                        <span className="MdClose">
                          <MdClose />
                        </span>
                      </span>
                      <span>{choice}</span>
                    </label>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
          <Row className="align-items-center">
            <Col sm={12}>
              <p>{validationResult}</p>
              <div className="footer-Quiz">
                <Row>
                  <Col md={12}>
                    <div className="progress">
                      <div
                        className="progress-bar"
                        style={{
                          width: `${
                            (completeQuestion / quiz.maxQuestions) * 100
                          }%`,
                          background: "#1363DF",
                        }}
                      ></div>
                      <div className="progress-content">
                        <span className="progress-value">
                          {(
                            (completeQuestion / quiz.maxQuestions) *
                            100
                          ).toFixed(0)}
                          %
                        </span>
                        <span className="progress-title">
                          Complete Keep it up!
                        </span>
                      </div>
                    </div>
                    <div className="modal-footer mt-1">
                      {!selectedAnsStatus && (
                        <button
                          type="button"
                          onClick={() => handleSubmitAnswer()}
                          className="btn btn-primary  btn-primary4"
                        >
                          {" "}
                          Submit Your Answers{" "}
                        </button>
                      )}
                      {selectedAnsStatus && (
                        <>
                          {currentQuestionIndex + 1 != quiz.maxQuestions && (
                            <button
                              type="button"
                              onClick={() => handleNextQuestion()}
                              className="btn btn-success  btn-primary4"
                            >
                              Next Question
                            </button>
                          )}

                          {currentQuestionIndex + 1 == quiz.maxQuestions && (
                            <button
                              type="button"
                              onClick={() => handleNextQuestion()}
                              className="btn btn-danger  btn-primary4"
                            >
                              {" "}
                              Exit
                            </button>
                          )}

                          
                          {retryActive &&  (
                            <button
                              type="button"
                              onClick={() => retryQuizReport()}
                              className="btn btn-primary  btn-primary4"
                            >
                              {" "}
                              Retry
                            </button>
                          )}

                          
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      )}
      <div className="rainfall" id="rainfall"></div>
    </div>
  );
}

export default LearningQuiz;
